export default __webpack_public_path__ + "static/program-869d045eb31e72c51b003ad6746117a4.pdf";